import formatPrice from "@/lib/formatPrice";
import styles from "@/styles/Price.module.scss";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function NonTrialFormatPriceSVOD(_ref) {
  var price = _ref.price,
      ext = _ref.ext;
  return /*#__PURE__*/_jsx("span", {
    className: "".concat(styles.price, " ").concat(styles.svod),
    children: /*#__PURE__*/_jsxs("span", {
      className: styles.slate,
      children: ["\u6708\u984D\uFF1A", /*#__PURE__*/_jsxs("span", {
        className: styles.bold,
        children: [formatPrice(price), "\u5186"]
      }), "\uFF08\u7A0E\u8FBC\uFF09", ext]
    })
  });
}